import React from 'react'
import RedeemAmazonMethod from '../../components/RedeemMethod/RedeemAmazonMethod';
import RedeemCoinbaseMethod from '../../components/RedeemMethod/RedeemCoinbaseMethod';
import classes from './redeemPage.module.css';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';
const Spacer = require('react-spacer')



export default function RedeemCoinbase() {
  useDarkOffersBackground();
  return (
    <>
    <h2 className={classes.sponsoredOffersHeading}>Choose your Reward Amount:</h2>
    <RedeemCoinbaseMethod/>
    <Spacer height={'100px'}/>
    </>
  )
}
